import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_FILTER] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.filter = payload
  },
  [types.SET_FILTERS] (state, payload) {
    state.filters = payload.data
    state.pagination = payload.meta.pagination
  }
}
